import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Canny: Customer Feedback Management Software and Tools';
const Description =
  'Canny helps you collect and organize feature requests to better understand customer needs and prioritize your roadmap.';
const Image = 'https://canny.io/images/canny-social.png';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createOrganization({
    '@id': 'https://canny.io/#organization',
    name: 'Canny',
    url: 'https://canny.io/',
    sameAs: [
      'https://www.linkedin.com/company/cannyhq/',
      'https://x.com/cannyhq',
      'https://www.youtube.com/@cannyio',
      'https://www.crunchbase.com/organization/canny-2',
      'https://www.instagram.com/canny.io/',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'support@canny.io',
    },
  }),
  JSONLDUtils.createWebSite({
    '@id': 'https://canny.io/#website',
    url: 'https://canny.io/',
    name: 'Canny',
    publisher: { '@id': 'https://canny.io/#organization' },
    inLanguage: 'en',
  }),
  JSONLDUtils.createSoftwareApplication({
    '@id': 'https://canny.io/#app',
    name: 'Canny',
    operatingSystem: 'Web',
    applicationCategory: 'BusinessApplication',
    description:
      'Canny is a customer feedback management tool that helps teams collect, organize, and prioritize product feedback to build better products.',
    url: 'https://canny.io/',
    isPartOf: { '@id': 'https://canny.io/#website' },
    offers: {
      '@type': 'Offer',
      url: 'https://canny.io/pricing',
      availability: 'https://schema.org/InStock',
      priceSpecification: {
        '@type': 'UnitPriceSpecification',
        price: '0',
        priceCurrency: 'USD',
        billingIncrement: 'monthly',
        billingDuration: 'P1M',
      },
    },
    featureList: [
      'Feedback collection and analysis',
      'AI-powered feedback discovery',
      'Roadmap planning, creation, and prioritization',
      'Changelog and product updates',
      'Bug tracking tools',
    ],
  }),
  JSONLDUtils.createWebPage({
    '@id': 'https://canny.io/#webpage',
    url: 'https://canny.io/',
    name: 'Canny — Customer Feedback Management',
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createBreadcrumbList([{ name: 'Home', item: 'https://canny.io/' }]),
]);

export default class LandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
          {
            name: 'zoom-domain-verification',
            content: 'ZOOM_verify_9d424f87baeb40b39d558d63ddb25072',
          },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
